import { SettingRow, SettingsPanel } from '@/components/ui/settings-panel';
import { Switch } from '@/components/ui/switch';
import { useAdminTabVisibility } from '@/hooks/useAdminTabVisibility';

export function AdminPanel() {
  const { showAdminTab, setVisibility } = useAdminTabVisibility();

  return (
    <div className="space-y-6">
      <SettingsPanel>
        <SettingRow
          htmlFor="admin-visibility"
          label="Show Platform"
          description="Display Platform in the navigation and admin-only features like case overview regeneration."
        >
          <div className="flex h-9 items-center justify-end">
            <Switch
              id="admin-visibility"
              checked={showAdminTab}
              onCheckedChange={setVisibility}
            />
          </div>
        </SettingRow>
      </SettingsPanel>
    </div>
  );
}
